export default {
    props: {
        productId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            product: null,
            ready: false,
        }
    },

    mounted() {
        const self = this;

        let promise = this.getProduct(this.productId);

        promise.then(function () {
            self.ready = true;
        }, function (error) {
            console.log(error);
        });
    },

    methods: {
        getProduct(id) {
            const self = this;
            return new Promise(function (resolve, reject) {
                axios.get(`/api/product/${id}`).then(function (response) {
                    if (Object.keys(response.data).length) {
                        self.product = response.data;
                    }
                    resolve(response.data);
                }).catch(function (error) {
                    reject(error);
                })
            });
        },
    },

    computed: {
        firstImage() {
            let image = '';
            if (this.product.media != null && this.product.media.length > 0) {
                this.product.media.forEach((m) => {
                    if (m.type.indexOf('link') < 0 && image == '') {
                        image = m.path;
                    }
                })
            }
            return image;
        }
    }
} 